import {
  useCameraSelection,
  useRememberCameraSelection,
} from '../../../hooks/useRememberCameraSelection'
import { DeviceInput } from './DeviceInput'

export type CameraSelectionProps = {
  /** The message that will be shown when no camera devices are found. */
  notFoundMsg?: string
  /** The label that will be shown for camera selection, it defaults to "Camera source". */
  label?: string
  /** Optional description to help the user understand what they are selecting */
  description?: string

  useCameraSelectionHook?: typeof useCameraSelection
}

export function CameraSelection({
  notFoundMsg = 'No camera devices found',
  label = 'Camera Source',
  useCameraSelectionHook = useRememberCameraSelection,
  ...props
}: CameraSelectionProps) {
  const { devices, selectedDevice, handleSelectCamera } = useCameraSelectionHook()

  return (
    <DeviceInput
      {...props}
      devices={devices.filter(({ deviceId }) => !!deviceId)}
      label={label}
      notFoundMsg={notFoundMsg}
      selectedDevice={selectedDevice}
      onChange={handleSelectCamera}
    />
  )
}
